// Main.js
import "./Main.css";
import React from "react";
import NewsGallery from "../NewsGallery/NewsGallery";
import Vacancies from "../Vacancies/Vacancies";
import CurrentMonthCalendar from "./MainCalendarV2/CurrentMonthCalendar";
// import CalendarComponent from "./MainCalendar/CalendarSection/CalendarSection";
// import MainNav from "../MainNav/MainNav";

const months = [
  "Январь",
  "Февраль",
  "Март",
  "Апрель",
  "Май",
  "Июнь",
  "Июль",
  "Август",
  "Сентябрь",
  "Октябрь",
  "Ноябрь",
  "Декабрь",
];

function Main() {
  const now = new Date();
  const monthTitle = `${months[now.getMonth()]} ${now.getFullYear()}`;
  return (
    <section className="main">
      <div className="main__columns">
        <div className="main__news-block">
          <NewsGallery />
        </div>
        <div className="main__calendar-block">
          <h2 className="main__title">{monthTitle}</h2>
          <CurrentMonthCalendar />
        </div>
      </div>
      <div className="main__vacancies-block">
        <Vacancies />
      </div>
    </section>
  );
}

export default Main;
